export default {
    actions: {

    },
    mutations: {
        setCruiseId: function(state, data) {
            state.cruiseId = data;
        },
    },
    getters: {
        cruiseId: state => state.cruiseId
    },
    state: {
        cruiseId: null
    },
};
